import { Component, inject, OnInit } from '@angular/core';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TermsAndConditions } from '@app/utils/interfaces/terms-and-conditions.interface';

@Component({
  selector: 'app-sign-up-terms',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './sign-up-terms.component.html',
  styleUrl: './sign-up-terms.component.scss',
})
export class SignUpTermsComponent implements OnInit {
  private readonly translate = inject(TranslateService);
  private readonly dialogRef = inject(MatDialogRef<SignUpTermsComponent>);
  public readonly data = inject<{ acceptTerms: boolean }>(MAT_DIALOG_DATA);

  public conditions: TermsAndConditions[] = [];

  public ngOnInit(): void {
    const translatedConditions: TermsAndConditions[] = this.translate.instant(
      'signUpPage.termsAndConditions.content.conditions',
    );
    this.conditions = Object.entries(translatedConditions).map(([key, value]) => ({
      key,
      label: value.label,
      description: value.description,
    }));
  }

  public closeModal(accepted: boolean): void {
    this.dialogRef.close(accepted);
  }
}
